import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { GlobalFlagsService } from '../../../services/global-flags.service';
import { UserService } from '../../../services/user.service';
import { UserFormActions } from '../user-form-actions';
import { UserForm } from '../../../models/UserForm';
import { from } from 'rxjs';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditUserComponent implements OnInit {

  constructor(private globalFlagsService: GlobalFlagsService,
    private userService: UserService,
    private dialog: MatDialog,
  ) { }

  action = UserFormActions.Edit;

  editUserForm: FormGroup;
  formSumitAttempt: boolean;
  isSendingForm: boolean;
  disableStates: boolean;

  formCreated = false;

  userDetails: UserForm = new UserForm();

  get userEmail() {
    return JSON.parse(localStorage.getItem('email'));
  }

  get user() {
    return JSON.parse(localStorage.getItem('username'));
  }

  ngOnInit() {
    this.getUserDetails();
  }

  getUserDetails() {
    this.globalFlagsService.displayLoad(true);
    const user = from(this.userService.getUserInfo());
    user
      .subscribe((res) => {
        this.createForm(user);
        this.globalFlagsService.displayLoad(false);
      }, (err) => {
        throw err;
      });
  }

  createForm(user: any) {
    this.userDetails.populateUser(user);
    this.formCreated = true;
  }

  onSubmitSuccess($event) {
    const message = 'User have been updated successfully';
    this.globalFlagsService.pushSuccessAlert({ message });
    window.scrollTo(0, 0);
  }

}
